import React from 'react';
import PropTypes from 'prop-types';
import save from '../../assets/check.svg'
import styles from './styles.module.scss';

const ButtonSubmitForm = ({
                            onClick,
                            disabled,
                          }) => {

  return (
    <div className={styles.stepsContainer}>
      <button
        type={'button'}
        className={(styles.buttonContainer)}
        onClick={onClick}
        disabled={disabled}
      >
        <img
          src={save}
          alt="save"
        />
      </button>
    </div>
  )
};

ButtonSubmitForm.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ButtonSubmitForm;
